// An invite link opened while signed out is remembered here, so the writer lands back on
// it after signing in, signing up or finishing onboarding (ProtectedRoute sends them).
// Story invites and plan invites are remembered separately.
const TOKEN = /^[A-Za-z0-9_-]{20,128}$/;

const store = (key: string) => ({
  save(token: string): void {
    if (!TOKEN.test(token)) return;
    try {
      localStorage.setItem(key, token);
    } catch {
      // Storage blocked: the writer can reopen the link from their email.
    }
  },
  get(): string | null {
    try {
      const token = localStorage.getItem(key);
      return token && TOKEN.test(token) ? token : null;
    } catch {
      return null;
    }
  },
  clear(): void {
    try {
      localStorage.removeItem(key);
    } catch {
      // nothing to clear
    }
  },
});

const storyInvite = store('plotweave.pendingInvite');
const planInvite = store('plotweave.pendingPlanInvite');

export const savePendingInvite = storyInvite.save;
export const pendingInvite = storyInvite.get;
export const clearPendingInvite = storyInvite.clear;

export const savePendingPlanInvite = planInvite.save;
export const pendingPlanInvite = planInvite.get;
export const clearPendingPlanInvite = planInvite.clear;
